import { useParams } from 'react-router-dom';
import { KioskPage } from './Kiosk';
import styles from './ScentMatch.module.css';

export function ScentMatchPage() {
    const { clientId } = useParams<{ clientId: string }>();

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <div>
                    <h1>🔍 ScentMatch</h1>
                    <p>AI-powered perfume search dan rekomendasi</p>
                </div>
                <a
                    href={`/k/${clientId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.openBtn}
                >
                    🔗 Open Full Screen
                </a>
            </header>

            <div className={styles.preview}>
                <div className={styles.previewFrame}>
                    <KioskPage />
                </div>
            </div>

            <div className={styles.info}>
                <h3>📱 Link untuk Pelanggan</h3>
                <div className={styles.linkBox}>
                    <input
                        type="text"
                        value={`${window.location.origin}/k/${clientId}`}
                        readOnly
                    />
                    <button onClick={() => {
                        navigator.clipboard.writeText(`${window.location.origin}/k/${clientId}`);
                        alert('Link copied!');
                    }}>
                        📋 Copy
                    </button>
                </div>
                <p>Bagikan link ini untuk akses langsung ke Kiosk ScentMatch</p>
            </div>
        </div>
    );
}
